import { render } from "./AudienceCtaControl.vue?vue&type=template&id=641ae07c"
import script from "./AudienceCtaControl.vue?vue&type=script&setup=true&lang=js"
export * from "./AudienceCtaControl.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/audience/AudienceCtaControl.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "641ae07c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('641ae07c', __exports__)) {
    api.reload('641ae07c', __exports__)
  }
  
  module.hot.accept("./AudienceCtaControl.vue?vue&type=template&id=641ae07c", () => {
    api.rerender('641ae07c', render)
  })

}


export default __exports__